import { render, staticRenderFns } from "./PainsSection.vue?vue&type=template&id=bfde91c6&scoped=true"
import script from "./PainsSection.vue?vue&type=script&lang=js"
export * from "./PainsSection.vue?vue&type=script&lang=js"
import style0 from "./PainsSection.vue?vue&type=style&index=0&id=bfde91c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfde91c6",
  null
  
)

export default component.exports